// extracted by mini-css-extract-plugin
module.exports = {"table":"Notifications_table__2MJbm","headerRow":"Notifications_headerRow__3hKBM"};